import { c as _c } from "react/compiler-runtime";
import { IcoForbid40 } from '@onefootprint/icons';
import { useRequestError } from '@onefootprint/request';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getLogger } from '@/idv/utils';
import { NavigationHeader } from '../../../../components/layout';
type ErrorComponentProps = {
  error?: unknown;
};
const ErrorComponent = t0 => {
  const $ = _c(22);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboarding.components.error"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const {
    getErrorCode
  } = useRequestError();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getLogger({
      location: "onboarding-components-error"
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    logError
  } = t2;
  let t3;
  if ($[2] !== error || $[3] !== getErrorCode || $[4] !== t) {
    t3 = () => {
      const errorCode = getErrorCode(error);
      if (errorCode === "E130") {
        return <Trans ns="idv" i18nKey={_temp} components={{
          onboardingSessionLink: <a href="https://docs.onefootprint.com/articles/integrate/onboarding-sessions#example-use-cases-guarantee-resolution-to-a-specific-user" target="_blank" rel="noopener noreferrer" className="text-label-2 text-accent hover:text-accent-hover">{t(_temp2)}</a>,
          fpId: <code className="align-baseline">fp_id</code>,
          userExternalId: <code className="align-baseline">user_external_id</code>
        }} />;
      }
      if (errorCode === "E124") {
        return t(_temp3);
      }
      return t(_temp4);
    };
    $[2] = error;
    $[3] = getErrorCode;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const getErrorMessage = t3;
  let t4;
  if ($[6] !== error) {
    t4 = () => {
      logError("ErrorComponent", error);
    };
    $[6] = error;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: false
    }} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IcoForbid40 color="error" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t(_temp5);
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <div className="flex flex-col items-center gap-1 justify-center">{t7}<p className="text-heading-3 text-primary fp-text">{t8}</p></div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== getErrorMessage) {
    t10 = getErrorMessage();
    $[15] = getErrorMessage;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <p className="text-body-2 text-primary text-center fp-text">{t10}</p>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t9) {
    t12 = <div className="flex flex-col gap-6 justify-center items-center min-h-[var(--loading-container-min-height)]">{t6}{t9}{t11}</div>;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};
export default ErrorComponent;
function _temp($) {
  return $.onboarding.components.error["description-authless-playbook-requires-backend"];
}
function _temp2($_0) {
  return $_0["onboarding-session"];
}
function _temp3($_1) {
  return $_1["description-business-not-owned-by-user"];
}
function _temp4($_2) {
  return $_2.description;
}
function _temp5($_3) {
  return $_3.title;
}